import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import './styles.scss';
import { getCalenderLastDays } from '../../utils/date';
import CalendarIcon from '../../assets/icons/iconComponents/Calendar';
import { useMediaQuery } from 'react-responsive';
import useTranslation from 'hooks/useTranslation';

const weekDays = [
  ['شنبه', 'ش'],
  ['یکشنبه', 'ی'],
  ['دوشنبه', 'د'],
  ['سه شنبه', 'س'],
  ['چهارشنبه', 'چ'],
  ['پنجشنبه', 'پ'],
  ['جمعه', 'ج'],
];

const AppDatePicker = ({
  selectedDate,
  setSelectedDate,
  onClose,
  placeholder,
  isFreePackage,
  renderInput,
  pullCalendarRefUp,
  onCalendarClose,
  rangeEnabled,
  renderSideMenu,
  monthsDisplay,
  position,
  className,
  containerClassName,
  inputClass = '',
}) => {
  const [hoveredDateButton, setHoveredDateButton] = useState(null);
  const datePickerRef = useRef();
  const { getTranslation, getAppLocale } = useTranslation('COMMON');
  const { t } = getTranslation();

  const appLocale = getAppLocale();
  const customWeekDays = appLocale === 'fa' ? weekDays : false;
  const calendarLocale = appLocale === 'fa' ? persian_fa : false;

  const mediumSize = useMediaQuery({
    query: '(max-width: 1330px)',
  });

  const averageSize = useMediaQuery({
    query: '(max-width: 1060px)',
  });

  const smallSize = useMediaQuery({
    query: '(max-width: 600px)',
  });

  function handleChange(value) {
    setSelectedDate(value);
  }

  const SidePlugin = () => {
    if (renderSideMenu) {
      return (
        <div className='filters-container'>
          <div
            onClick={() => setSelectedDate(getCalenderLastDays(1))}
            className='filter-item'
            onMouseOver={() => setHoveredDateButton(0)}
            onMouseLeave={() => setHoveredDateButton(null)}
          >
            <span className='icon_wrapper'>
              <CalendarIcon
                color={hoveredDateButton === 0 ? '#fff' : '#757575'}
              />
            </span>
            <span>{t('YESTERDAY')}</span>
          </div>
          <div
            onClick={() => setSelectedDate(getCalenderLastDays(0))}
            className='filter-item'
            onMouseOver={() => setHoveredDateButton(1)}
            onMouseLeave={() => setHoveredDateButton(null)}
          >
            <span className='icon_wrapper'>
              <CalendarIcon
                color={hoveredDateButton === 1 ? '#fff' : '#757575'}
              />
            </span>
            <span>{t('TODAY')}</span>
          </div>
          <div
            onClick={() => setSelectedDate(getCalenderLastDays(6))}
            className='filter-item'
            onMouseOver={() => setHoveredDateButton(2)}
            onMouseLeave={() => setHoveredDateButton(null)}
          >
            <span className='icon_wrapper'>
              <CalendarIcon
                color={hoveredDateButton === 2 ? '#fff' : '#757575'}
              />
            </span>
            <span>{t('PAST_SEVEN_DAYS')}</span>
          </div>
          <div
            onClick={() => setSelectedDate(getCalenderLastDays(13))}
            className='filter-item'
            onMouseOver={() => setHoveredDateButton(3)}
            onMouseLeave={() => setHoveredDateButton(null)}
          >
            <span className='icon_wrapper'>
              <CalendarIcon
                color={hoveredDateButton === 3 ? '#fff' : '#757575'}
              />
            </span>
            <span>{t('PAST_14_DAYS')}</span>
          </div>
          <div
            onClick={() => setSelectedDate(getCalenderLastDays(364))}
            className='filter-item'
            onMouseOver={() => setHoveredDateButton(4)}
            onMouseLeave={() => setHoveredDateButton(null)}
          >
            <span className='icon_wrapper'>
              <CalendarIcon
                color={hoveredDateButton === 4 ? '#fff' : '#757575'}
              />
            </span>
            <span>{t('PAST_ONE_YEAR')}</span>
          </div>
        </div>
      );
    }

    return null;
  };

  const FooterPlugin = () => {
    return (
      <div className='calender-footer'>
        <button onClick={() => datePickerRef.current.closeCalendar()}>
          {t('DATE_PICKER_SUBMIT')}
        </button>
      </div>
    );
  };

  useEffect(() => {
    if (selectedDate && onClose) {
      onClose(selectedDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  useEffect(() => {
    if (pullCalendarRefUp) pullCalendarRefUp(datePickerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`date-container ${className}`}>
      <DatePicker
        containerClassName={containerClassName}
        disabled={isFreePackage && true}
        ref={datePickerRef}
        value={selectedDate}
        placeholder={placeholder}
        onChange={handleChange}
        onClose={() => {
          setHoveredDateButton(null);
          if (onCalendarClose) onCalendarClose(false);
        }}
        position={averageSize ? 'bottom' : position}
        range={rangeEnabled}
        numberOfMonths={mediumSize ? 1 : monthsDisplay}
        calendar={appLocale === 'fa' ? persian : ''}
        locale={calendarLocale}
        weekDays={customWeekDays}
        plugins={[
          <SidePlugin position={smallSize ? 'top' : 'right'} />,
          <FooterPlugin position='bottom' />,
        ]}
        render={renderInput}
        inputClass={inputClass}
      />
    </div>
  );
};

AppDatePicker.defaultProps = {
  rangeEnabled: true,
  renderSideMenu: true,
  monthsDisplay: 2,
  className: '',
  containerClassName: '',
};

export default AppDatePicker;
